import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { IChallenge } from '../challenge-schema';

export async function getPublicChallengeApi(id: number) {
  return getRequest<IAPI<IChallenge>>({
    path: `/challenges/${id}`,
  });
}
